"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var attempts = 1;
var maxAttemptsToFindCroct = 5;
function croct(criteria, services) {
    return __awaiter(this, void 0, void 0, function () {
        var value, croctExists;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    value = criteria[0].values[0];
                    return [4 /*yield*/, checkIfCroctExists()];
                case 1:
                    croctExists = _a.sent();
                    if (!croctExists) {
                        services.logger.debug("Could not find croct at the window. URL: ".concat(services.browserEnvironment.currentUrl));
                        return [2 /*return*/, false];
                    }
                    else {
                        services.logger.debug("find croct with attempt: ".concat(attempts));
                    }
                    return [2 /*return*/, window.croct.evaluator
                            .evaluate(value, { timeout: 10000 })
                            .then(function (res) {
                            if (typeof res !== 'boolean') {
                                services.logger.error("Croct API return unexpected value: ".concat(res));
                                return false;
                            }
                            return res;
                        })
                            .catch(function (e) {
                            services.logger.error("Croct API return error: ".concat(e));
                            return false;
                        })];
            }
        });
    });
}
exports.default = croct;
var checkIfCroctExists = function () {
    return new Promise(function (resolve) {
        var checkCroctAttempt = function () {
            if (attempts > maxAttemptsToFindCroct) {
                resolve(false);
            }
            else if (window.croct) {
                resolve(true);
            }
            else {
                attempts++;
                setTimeout(checkCroctAttempt, attempts * 1000);
            }
        };
        checkCroctAttempt();
    });
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY3JvY3QuanMiLCJzb3VyY2VSb290Ijoic3JjLyIsInNvdXJjZXMiOlsic3JjL2xpYi9zZXJ2aWNlcy90YXJnZXRzL2Nyb2N0LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBR0EsSUFBSSxRQUFRLEdBQUcsQ0FBQyxDQUFBO0FBQ2hCLElBQU0sc0JBQXNCLEdBQUcsQ0FBQyxDQUFBO0FBRWhDLFNBQThCLEtBQUssQ0FBQyxRQUFrQyxFQUFFLFFBQXNCOzs7Ozs7b0JBQ3BGLEtBQUssR0FBRyxRQUFRLENBQUMsQ0FBQyxDQUFDLENBQUMsTUFBTSxDQUFDLENBQUMsQ0FBQyxDQUFBO29CQUVmLHFCQUFNLGtCQUFrQixFQUFFLEVBQUE7O29CQUF4QyxXQUFXLEdBQUcsU0FBMEI7b0JBRTlDLElBQUksQ0FBQyxXQUFXLEVBQUU7d0JBQ2QsUUFBUSxDQUFDLE1BQU0sQ0FBQyxLQUFLLENBQUMsbURBQTRDLFFBQVEsQ0FBQyxrQkFBa0IsQ0FBQyxVQUFVLENBQUUsQ0FBQyxDQUFBO3dCQUMzRyxzQkFBTyxLQUFLLEVBQUE7cUJBQ2Y7eUJBQU07d0JBQ0gsUUFBUSxDQUFDLE1BQU0sQ0FBQyxLQUFLLENBQUMsbUNBQTRCLFFBQVEsQ0FBRSxDQUFDLENBQUE7cUJBQ2hFO29CQUVELHNCQUFRLE1BQWMsQ0FBQyxLQUFLLENBQUMsU0FBUzs2QkFDakMsUUFBUSxDQUFDLEtBQUssRUFBRSxFQUFFLE9BQU8sRUFBRSxLQUFLLEVBQUUsQ0FBQzs2QkFDbkMsSUFBSSxDQUFDLFVBQUMsR0FBUTs0QkFDWCxJQUFJLE9BQU8sR0FBRyxLQUFLLFNBQVMsRUFBRTtnQ0FDMUIsUUFBUSxDQUFDLE1BQU0sQ0FBQyxLQUFLLENBQUMsNkNBQXNDLEdBQUcsQ0FBRSxDQUFDLENBQUE7Z0NBQ2xFLE9BQU8sS0FBSyxDQUFBOzZCQUNmOzRCQUNELE9BQU8sR0FBRyxDQUFBO3dCQUNkLENBQUMsQ0FBQzs2QkFDRCxLQUFLLENBQUMsVUFBQyxDQUFNOzRCQUNWLFFBQVEsQ0FBQyxNQUFNLENBQUMsS0FBSyxDQUFDLGtDQUEyQixDQUFDLENBQUUsQ0FBQyxDQUFBOzRCQUNyRCxPQUFPLEtBQUssQ0FBQTt3QkFDaEIsQ0FBQyxDQUFDLEVBQUE7Ozs7Q0FDVDtBQXpCRCx3QkF5QkM7QUFFRCxJQUFNLGtCQUFrQixHQUFHO0lBQ3ZCLE9BQU8sSUFBSSxPQUFPLENBQVUsVUFBQyxPQUFPO1FBQ2hDLElBQU0saUJBQWlCLEdBQUc7WUFDdEIsSUFBSSxRQUFRLEdBQUcsc0JBQXNCLEVBQUU7Z0JBQ25DLE9BQU8sQ0FBQyxLQUFLLENBQUMsQ0FBQTthQUNqQjtpQkFBTSxJQUFLLE1BQWMsQ0FBQyxLQUFLLEVBQUU7Z0JBQzlCLE9BQU8sQ0FBQyxJQUFJLENBQUMsQ0FBQTthQUNoQjtpQkFBTTtnQkFDSCxRQUFRLEVBQUUsQ0FBQTtnQkFDVixVQUFVLENBQUMsaUJBQWlCLEVBQUUsUUFBUSxHQUFHLElBQUksQ0FBQyxDQUFBO2FBQ2pEO1FBQ0wsQ0FBQyxDQUFBO1FBQ0QsaUJBQWlCLEVBQUUsQ0FBQTtJQUN2QixDQUFDLENBQUMsQ0FBQTtBQUNOLENBQUMsQ0FBQSJ9